import { Schema } from '../../data/dto/schema';

export const DeliveryOrderConfigSchema = {
    id: Schema.String,
    active: Schema.Boolean,
    pickup_prep_time: Schema.Number,
    late_dropoff_notification_mins: Schema.Number,
    late_pickup_notification_mins: Schema.Number,
    pickup_notes: Schema.String,
    location_code: Schema.String,
    deliverable_action: Schema.String,
    undeliverable_action: Schema.String,
    dispatch_mode: Schema.String,
    default_item_size: Schema.String,
    default_customer_name: Schema.String,
    service_providers: Schema.Auto,
    default_requires_id: Schema.Boolean,
    requires_id_keywords: Schema.Auto,
};
